import {SIZE_CHOICES, getColor, MDCButtonComponent} from './button.component';

class BigButtonComponent extends MDCButtonComponent{
  constructor($element) {
    'ngInject';
    super($element);
    this.size = SIZE_CHOICES.LARGE;

    this.isDisabled = false;
    this.isWarning = false;
  }

  getButtonColor() {
    return getColor(this.light, this.highlight, this.isWarning);
  }
}

const config = MDCButtonComponent.componentConfig(BigButtonComponent);

const mod = angular.module('common.materialComponents.bigButton', [
])

.component('bigButton', config);

export default mod.name;
